export default "__VITE_ASSET__3c2b37a3__"